import { AlertRecord, AlertState, AlertType } from "./Types";
import * as UUID from '../utils/Uuid';

/**
 * Generates a human readable UUID that contains parts of the passed in base uuid. 
 * @param type 
 * @param uuidBase Base UUID to extend with word "ALRT" and AlertType
 * @returns 
 */
export function generateMockAlertBase(type: AlertType, uuidBase?: string): AlertRecord {
    if (!uuidBase) uuidBase = UUID.generate();

    const now = new Date();
    return new AlertRecord({
        created: now,
        deviceId: 1,
        id: Math.floor(Math.random() * 100000),
        siteId: Math.floor(Math.random() * 100000),
        state: AlertState.Open,
        type,
        updated: now,
        uuid: UUID.modifySection(4, uuidBase, "ALRT" + type),
    });
}